export const StateProxy = {
    createProxy(obj) {
        const events = {};
        const handler1 = {
            get(target, prop, receiver) {
                if (events[prop]) {
                    events[prop]["get"].forEach((_) => _());
                }
                return Reflect.get(target, prop, receiver);
            },
            set(target, prop, newValue, receiver) {
                const oldValue = target[prop];
                target[prop] = newValue;
                if (events[prop]) {
                    events[prop]["set"].forEach((_) => _(newValue));
                    if (oldValue != newValue) {
                        events[prop]["change"].forEach((_) => _(oldValue, newValue));
                    }
                }
                return true;
            },
        };
        const update = (property, event, run) => {
            events[property] ??= {
                change: [],
                get: [],
                set: [],
            };
            events[property][event].push(run);
        };
        return [update, new Proxy(obj, handler1)];
    },
};
